import React from "react"



const StepOne = () => {
    return(
        <div className="step-1 steps">
            <div className="display-lap2">
                <h1>Apply Online</h1>
                <p>Apply online 24/7 by selecting your desired loan amount and tenure. No guarantors, collaterals or long forms.</p>
            </div>
        </div>
    )
}

export default StepOne